import { computed } from 'vue';
import { useType } from '~/modules/type/composables/useType';
import useSize from '~/modules/size/composables/useSize';
import { useProductFlags } from '~/modules/featureControl/composables/useProductFlags';
/**
 * @returns {{ selected2ndVariantName: import('vue').ComputedRef<string> }}
 */
export default function useSelected2ndVariant() {
  const { selectedSize } = useSize();
  const { selectedType } = useType();

  const { isTypeDrivenThirdVariantFlag: isTypeDriven } = useProductFlags();
  const isSizeDriven = !isTypeDriven;

  const selected2ndVariantName = computed(() => {
    if (isSizeDriven) {
      return selectedSize.value?.name || '';
    }
    return selectedType.value?.name || '';
  });

  return {
    selected2ndVariantName,
  };
}
